import { render, staticRenderFns } from "./ShowActivityDetails.vue?vue&type=template&id=0538a75f&"
import script from "./ShowActivityDetails.vue?vue&type=script&lang=js&"
export * from "./ShowActivityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports